import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { routesTitles } from '@/router/constants';

import { setRoute } from '@/store/actions/route.actions';

import { useAppDispatch } from '@/hooks/redux-helpers';

export function useRouteTitle(path) {
  const { t } = useTranslation();

  const key: string | undefined = Object.keys(routesTitles).reduce<string | undefined>((prev, current) => {
    const expression = current.replaceAll('/', '/').replaceAll('*', '[^/]+');

    const rgx = new RegExp(expression);
    if (rgx.test(path)) {
      return current;
    } else {
      return prev;
    }
  }, undefined);

  return t(routesTitles[key]);
}

export function useRoute() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const title = useRouteTitle(location.pathname);

  useEffect(() => {
    dispatch(
      setRoute({
        title,
        path: location.pathname,
      }),
    );
  }, [location, dispatch, title]);

  return null;
}
export default useRoute;
